module.exports = __webpack_public_path__ + "static/media/iconCanvas05.b022b109.svg";